<template>
  <span :style="{ cursor: 'pointer'}">
    <span @click="showDialog=true">
      <slot/>
    </span>

    <v-dialog v-model="showDialog" :max-width="maxWidth">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <div v-html="body" />
<!--          <div class="font-weight-bold" v-html="iframeSrc">{{ iframeSrc }}</div>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="btnCancel" text @click="showDialog=false">
            <v-icon small left  v-if="btnCancelIcon">{{ btnCancelIcon }}</v-icon>
            {{ btnCancel }}
          </v-btn>
          <v-btn v-if="btnOk" text @click="showDialog=false">
            <v-icon small left v-if="btnOkIcon">{{ btnOkIcon }}</v-icon>
            {{ btnOk }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
name: "DialogModal",
  props: {
    maxWidth: {
      type: String,
      default: '500px',
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    btnOk: {
      type: String,
      default: 'OK',
    },
    btnOkIcon: {
      type: String,
      default: 'mdi-check',
    },
    btnCancel: {
      type: String,
      default: 'Cancel',
    },
    btnCancelIcon: {
      type: String,
      default: 'mdi-close',
    },
  },
  data: () => ({
    showDialog: false,
  })
}

</script>

<style scoped>

</style>